import { render, staticRenderFns } from "./SelectSpecDialog.vue?vue&type=template&id=5b8337ab&scoped=true"
import script from "./SelectSpecDialog.vue?vue&type=script&lang=js"
export * from "./SelectSpecDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectSpecDialog.vue?vue&type=style&index=0&id=5b8337ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8337ab",
  null
  
)

export default component.exports